/** Dashboard quick_filters / carrier-style shipping status codes */
export const SHIPPING_STATUSES: Record<string, string> = {
  SA: 'Accepted',
  PL: 'Processing',
  DF: 'In Transit',
  AF: 'Arrived Hub',
  RR: 'Customs Processing',
  SM: 'Scheduled Movement',
  CR: 'Customs Cleared',
  AR: 'At Delivery Facility',
  WC: 'Out for Delivery',
  OK: 'Delivered',
};
